import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import testService from './testService'


const initialState = {
  data:   [],
  isError: false,
  isSuccess: false,
  isLoading: false, 
  message: '', 

  allCreatedTestdata:   [],
  allCreatedTestisError: false,
  allCreatedTestisSuccess: false,
  allCreatedTestisLoading: false, 
  allCreatedTestmessage: '', 
  
  createdTestDetailsdata:   [],
  createdTestDetailsisError: false,
  createdTestDetailsisSuccess: false,
  createdTestDetailsisLoading: false, 
  createdTestDetailsmessage: '', 

  sendTestdata:   [],
  sendTestisError: false,
  sendTestisSuccess: false,
  sendTestisLoading: false, 
  sendTestmessage: '', 

  evaluationUpdatedata:   [],
  evaluationUpdateisError: false,
  evaluationUpdateisSuccess: false,
  evaluationUpdateisLoading: false, 
  evaluationUpdatemessage: '', 

  eligibilityCheckdata:   [],
  eligibilityCheckisError: false,
  eligibilityCheckisSuccess: false,
  eligibilityCheckisLoading: false, 
  eligibilityCheckmessage: '', 

  sendEmaildata:   [],
  sendEmailisError: false,
  sendEmailisSuccess: false,
  sendEmailisLoading: false, 
  sendEmailmessage: '', 

}

 

// Create Test
export const createTest = createAsyncThunk('test/createTest', async ( data,thunkAPI) => {
  try { 
    return await testService.createTest(data)
  } catch (error:any) {
    const message =
      error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})
 
// Get All Created Test 
export const allCreatedTest = createAsyncThunk('test/allCreatedTest', async ( data,thunkAPI) => {
  try { 
    return await testService.allCreatedTest( )
  } catch (error:any) {
    const message =
      error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})

// Created Test Details 
export const createdTestDetails = createAsyncThunk('test/createdTestDetails', async ( data:any,thunkAPI) => {
  try { 
    return await testService.createdTestDetails(data )
  } catch (error:any) { 
    const message =
      error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})
 

// Send Test  
export const sendTest = createAsyncThunk('test/sendTest', async ( data,thunkAPI:any  ) => {
  try { 
    return await testService.sendTest(data )
  } catch (error:any) { 
    const message = 
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})


// Evaluation Update 
export const evaluationUpdate = createAsyncThunk('test/evaluationUpdate', async ( data:any,thunkAPI:any  ) => {
  try { 
    	
    return await testService.evaluationUpdate(data)
  } catch (error:any) { 
    const message = error.message  
    return thunkAPI.rejectWithValue(message)
  }
})


 
//Eligibility Check
export const eligibilityCheck = createAsyncThunk('test/eligibilityCheck', async ( data:any,thunkAPI:any  ) => {
  try { 
    	
    return await testService.eligibilityCheck(data)
  } catch (error:any) { 
    const message =  error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})

 
//Send Email  
export const sendEmail = createAsyncThunk('test/sendEmail', async ( data:any,thunkAPI:any  ) => {
  try { 
    	
    return await testService.sendEmail(data)
  } catch (error:any) { 
    const message =  error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})
 
 
 
 
 

export const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    reset: (state) => {  
      state.isLoading = false
      state.isSuccess = false
      state.isError = false
      state.message = ''  

      state.allCreatedTestisLoading = false
      state.allCreatedTestisSuccess = false
      state.allCreatedTestisError = false
      state.allCreatedTestmessage = ''  

      state.createdTestDetailsisLoading = false
      state.createdTestDetailsisSuccess = false
      state.createdTestDetailsisError = false
      state.createdTestDetailsmessage = ''  

  
      state.sendTestisLoading = false
      state.sendTestisSuccess = false
      state.sendTestisError = false
      state.sendTestmessage = ''  

      state.evaluationUpdateisLoading = false
      state.evaluationUpdateisSuccess = false
      state.evaluationUpdateisError = false
      state.evaluationUpdatemessage = ''  

      state.eligibilityCheckisLoading = false
      state.eligibilityCheckisSuccess = false
      state.eligibilityCheckisError = false
      state.eligibilityCheckmessage = ''  


      state.sendEmailisLoading = false
      state.sendEmailisSuccess = false
      state.sendEmailisError = false
      state.sendEmailmessage = ''  
    },
    
     
  },
  extraReducers: (builder) => {
    builder  
    .addCase(createTest.pending, (state) => {
        state.isLoading = true 
      })
      .addCase(createTest.fulfilled, (state:any, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.data = action.payload 
      })
      .addCase(createTest.rejected, (state:any, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.data = [] 
      })

    .addCase(allCreatedTest.pending, (state) => {
        state.allCreatedTestisLoading = true 
      })
      .addCase(allCreatedTest.fulfilled, (state:any, action) => {
        state.allCreatedTestisLoading = false
        state.allCreatedTestisSuccess = true
        state.allCreatedTestdata = action.payload 
      })
      .addCase(allCreatedTest.rejected, (state:any, action) => {
        state.allCreatedTestisLoading = false
        state.allCreatedTestisError = true
        state.allCreatedTestmessage = action.payload
        state.allCreatedTestdata = [] 
      })

    .addCase(createdTestDetails.pending, (state) => {
        state.createdTestDetailsisLoading = true 
      })
      .addCase(createdTestDetails.fulfilled, (state:any, action) => {
        state.createdTestDetailsisLoading = false
        state.createdTestDetailsisSuccess = true
        state.createdTestDetailsdata = action.payload 
      })
      .addCase(createdTestDetails.rejected, (state:any, action) => {
        state.createdTestDetailsisLoading = false
        state.createdTestDetailsisError = true
        state.createdTestDetailsmessage = action.payload
        state.createdTestDetailsdata = [] 
      })
      
    .addCase(sendTest.pending, (state) => {
        state.sendTestisLoading = true 
      })
      .addCase(sendTest.fulfilled, (state:any, action) => {
        state.sendTestisLoading = false
        state.sendTestisSuccess = true
        state.sendTestdata = action.payload 
      })
      .addCase(sendTest.rejected, (state:any, action) => {
        state.sendTestisLoading = false
        state.sendTestisError = true
        state.sendTestmessage = action.payload
        state.sendTestdata = [] 
      })
      
    .addCase(evaluationUpdate.pending, (state) => {
        state.evaluationUpdateisLoading = true 
      })
      .addCase(evaluationUpdate.fulfilled, (state:any, action) => {
        state.evaluationUpdateisLoading = false
        state.evaluationUpdateisSuccess = true
        state.evaluationUpdatedata = action.payload 
      })
      .addCase(evaluationUpdate.rejected, (state:any, action) => {
        state.evaluationUpdateisLoading = false
        state.evaluationUpdateisError = true
        state.evaluationUpdatemessage = action.payload
        state.evaluationUpdatedata = [] 
      })

    .addCase(eligibilityCheck.pending, (state) => {
        state.eligibilityCheckisLoading = true 
      })
      .addCase(eligibilityCheck.fulfilled, (state:any, action) => {
        state.eligibilityCheckisLoading = false
        state.eligibilityCheckisSuccess = true
        state.eligibilityCheckdata = action.payload 
      })
      .addCase(eligibilityCheck.rejected, (state:any, action) => {
        state.eligibilityCheckisLoading = false
        state.eligibilityCheckisError = true
        state.eligibilityCheckmessage = action.payload
        state.eligibilityCheckdata = [] 
      })

    .addCase(sendEmail.pending, (state) => {
        state.sendEmailisLoading = true 
      })
      .addCase(sendEmail.fulfilled, (state:any, action) => {
        state.sendEmailisLoading = false
        state.sendEmailisSuccess = true
        state.sendEmaildata = action.payload 
      })
      .addCase(sendEmail.rejected, (state:any, action) => {
        state.sendEmailisLoading = false
        state.sendEmailisError = true
        state.sendEmailmessage = action.payload
        state.sendEmaildata = [] 
      })
       
  },
})

export const { reset } = testSlice.actions
export default testSlice.reducer